export default function NotifyDot({ show }) {
    if (!show) return null

    return (
        <span className="absolute -right-0.5 -top-0.5 z-10 h-2.5 w-2.5 scale-[0.92] rounded-full bg-(--accent-green)">
            <span className="absolute inline-flex w-full h-full bg-(--accent-green) rounded-full opacity-75 animate-ping"></span>
        </span>
    )
}
